import { render, staticRenderFns } from "./SingleCategory.vue?vue&type=template&id=7f348d4b&scoped=true&"
import script from "./SingleCategory.vue?vue&type=script&lang=js&"
export * from "./SingleCategory.vue?vue&type=script&lang=js&"
import style0 from "./SingleCategory.vue?vue&type=style&index=0&id=7f348d4b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f348d4b",
  null
  
)

export default component.exports